import { render, staticRenderFns } from "./UploadCard.vue?vue&type=template&id=0982a031&scoped=true"
import script from "./UploadCard.vue?vue&type=script&lang=js"
export * from "./UploadCard.vue?vue&type=script&lang=js"
import style0 from "./UploadCard.vue?vue&type=style&index=0&id=0982a031&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0982a031",
  null
  
)

export default component.exports